<template>
    <div>
        <div class="header-container">
      <Header></Header>
    </div>
      <i id="back-login-arrow" class="material-icons" @click="handleBackLogin">arrow_back</i>
      <div class="login-container">
        <div class="form-container">
          <h2 class="accedi">Accedi</h2>
          <form @submit.prevent="login">
            <div class="form-group">
              <label for="username">Username:</label>
              <input type="text" id="username" v-model="username" required>
            </div>
            <div class="form-group">
              <label for="password">Password:</label>
              <div class="password-wrapper">
                <input :type="showPassword ? 'text' : 'password'" id="password" v-model="password" required>
                <i class="material-icons toggle-password" @click="showPassword = !showPassword">
                  {{ showPassword ? 'visibility_off' : 'visibility' }}
                </i>
              </div>
            </div>
            <button id="login-button" type="submit">Accedi</button>
          </form>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Header from '@/components/homepage/Header.vue';
  import { login } from '@/api/login';
  
  export default {
    components: {
      Header,
    },
    data() {
      return {
        username: '',
        password: '',
        showPassword: false,
      };
    },
    methods: {
      async login() {
        try {
          const success = await login(this.username, this.password);
          if (success) {
            this.$router.push('/admin');
          } else {
            alert('Credenziali non valide. Riprova.');
          }
        } catch (error) {
          console.error('Errore durante il login:', error);
          alert('Si è verificato un errore durante il login. Riprova più tardi.');
        }
      },
      handleBackLogin() {
        this.$router.push('/');
      },
    },
  };
  </script>
  
  <style scoped>
  .header-container{
    text-align: center;
  }
  #back-login-arrow {
    color: var(--text-color);
    font-size: 30px;
    position: absolute;
    top: 13px;
    left: 10px;
    z-index: 999;
  }
  .accedi {
    text-align: center;
    color: var(--secondary-color);
    font-size: 25px;
    font-weight: 600;
  }
  .form-container {
    background-color: var(--primary-color);
    padding: 5%;
    border-radius: 20px;
    box-shadow: var(--custom-box-shadow);
  }
  .login-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: var(--background-color);
  }
  .login-container form {
    width: 300px;
  }
  .form-group {
    margin-bottom: 15px;
  }
  label {
    color: var(--text-color);
  }
input[type="text"],
input[type="password"] {
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid var(--border-color);
}
.password-wrapper {
  position: relative;
}
.password-wrapper input {
  width: 100%;
  padding-right: 36px;
  box-sizing: border-box;
}
.toggle-password {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #888;
  font-size: 20px;
  user-select: none;
}
  button {
    display: block;
    margin: auto;
    margin-top: 25px;
    margin-bottom: 10px;
    padding: 10px 20px;
    background-color: var(--accent-color);
    color: var(--text-color);
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  </style>
  